<template>
  <b-modal :active.sync="isActive" :width="640" scroll="keep">
    <div class="card pa-40">
      <div class="card-content has-text-centered">
        <img
          src="@/assets/images/general/alert.svg"
          v-if="type === 'is-confirmation'">
        <p class="has-text-weight-bold has-text-grid-1 mt-20 pb-10">
          {{message}}
        </p>
        <p class="has-text-default is-size-14px">
          {{infoMessage}}
        </p>
      </div>
      <div class="has-text-centered mt-10">
        <b-button
          type="is-transparent"
          class="has-text-default"
          @click="isActive = false">
          {{libelleBtnCancel}}
        </b-button>
        <b-button
          :type="typeBtn"
          class="has-text-weight-bold ml-20"
          @click="$emit('isValide')">
          {{libelleBtnValide}}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    modalIsActive: Boolean,
    message: String,
    infoMessage: String,
    libelleBtnValide: String,
    libelleBtnCancel: String,
    type: String,
  },
  computed: {
    isActive: {
      get() {
        return this.modalIsActive;
      },
      set(value) {
        this.$emit('modalIsClose', value);
      }
    },
    typeBtn() {
      if (this.type === 'is-confirmation') return 'is-warning';
      return '';
    },
  },
};
</script>

<style>

</style>
